import create from 'zustand';
 import { subscriptionService } from '../services'; 

export interface subscriptionHistory {
  plan: string;
  startDate: Date | null | undefined;
  endDate: Date | null | undefined;
  costPerMonth: number;
}

export interface subscription {
  status?: string;
  nextDate?: Date | undefined;
  plan: string;
  daysLeft?: number | undefined;
  costPerMonth?: number;
  usage?: {
    expense: number;
    invoice: number;
    reports: number;
    customers: number;
  };
  limits: {
    expense: number;
    invoice: number;
    reports: number;
    customers: number;
  };
  companyId: string;
   id: number;
  createdAt: string;
  updatedAt: string;
  "companyId#status": string;
  paymentStatus: string;
}



interface SubscriptionStore {
  subscription: subscription;
  subscriptionList: {
    [name: string]: {
     name: string,
      price: number,
      limits: {
          invoices: number,
          expenses: number,
          reports: number,
          customers: number
      },
      features: {
          support: boolean
      }
  }
} | undefined | null,
  history: subscriptionHistory[];
  isLoading: boolean;
  error: any;
  getSubscription: () => Promise<void>;
  fetchListSubscription: () => Promise<void>;
  canPerformAction?: (actionType: string) => boolean;
  incrementUsage: (actionType: string) => void;
  
};

export const useSubscriptionStore = create<SubscriptionStore>((set, get) => ({
  subscription: {
    status: '',
    nextDate: new Date(),
    plan: '',
    daysLeft: 0,
    costPerMonth: 0,
    usage: {
      expense: 0,
      invoice: 0,
      reports: 0,
      customers: 0,
    },
    limits: {
      expense: 0,
      invoice: 0,
      reports: 0,
      customers: 0
    },
      companyId: "",
      id: 0,
     createdAt: "",
     updatedAt: "",
     "companyId#status": "",
     paymentStatus: "",
  },
  subscriptionList: undefined,
  history: [],
  isLoading: false,
  error: null,
  getSubscription: async () => {
    try {
     const res = await subscriptionService.get("/subscriptions/active")
     console.log(res.data)
    set({
      subscription: res.data as unknown as subscription 
    })
    } catch (e:any) {
      set({ isLoading: false, error: e.message });
    }
  },
  fetchListSubscription: async () => {
    set({ isLoading: true });
    try {
      const res = await subscriptionService.get('/subscriptions');
      set({
        subscriptionList: res.data,
        // history: res.data.data.history,
        isLoading: false,
      });
    } catch (e: any) {
      set({ isLoading: false, error: e.message });
    }
  },

//   canPerformAction: (actionType: string) => {
//     const { usage, limits } = get().subscription;
//     // return usage[actionType] < limits[actionType];
//   },

  incrementUsage: (actionType: string) => {
    set((state) => {
    //   state.subscription.usage[actionType] += 1;
      return state;
    });
  },
}));